var _defineProperty = require("@babel/runtime/helpers/defineProperty");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate cutPipeBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const alertResult = async (title, message) => {
    const alertSource = {
      type: 'alertBehavior',
      title,
      message,
      options: [{
        title: 'OK',
        actions: []
      }]
    };
    await evaluateSource(alertSource, content, parentContentPath, transientContext, nativeFunctions);
  };
  const info = await evaluateSource(source.info, content, parentContentPath, transientContext, nativeFunctions);
  if (info === undefined) {
    await alertResult('Error', 'Misconfiguration.');
    return;
  }
  const _info$oldPipe = info.oldPipe,
    oldPipe = _info$oldPipe === void 0 ? {} : _info$oldPipe,
    _info$newPipe = info.newPipe,
    newPipe = _info$newPipe === void 0 ? {} : _info$newPipe,
    _info$currentLength = info.currentLength,
    currentLength = _info$currentLength === void 0 ? 0 : _info$currentLength;
  const _content$parts = content.parts,
    parts = _content$parts === void 0 ? {} : _content$parts,
    _content$bends = content.bends,
    bends = _content$bends === void 0 ? {} : _content$bends;
  const _newPipe$length = newPipe.length,
    newLength = _newPipe$length === void 0 ? 0 : _newPipe$length;
  const oldLength = currentLength - newLength;
  const makeContent = pipe => {
    const barcodes = pipe.barcodes,
      _pipe$bends = pipe.bends,
      bendSelections = _pipe$bends === void 0 ? {} : _pipe$bends,
      stage = pipe.stage;
    const fullBends = Object.keys(bendSelections).reduce((acc, key) => {
      acc[key] = bends[key];
      return acc;
    }, {});
    return {
      barcodes,
      bends: fullBends,
      parts,
      stage
    };
  };
  const oldContent = makeContent(oldPipe);
  const newContent = _objectSpread(_objectSpread({}, content), makeContent(newPipe));
  newContent.identifier = newPipe.identifier;
  newContent.currentLength = newLength;
  newContent.title = "Pipe: ".concat(newPipe.identifier);
  newContent.parentPipeIdentifier = oldPipe.identifier;
  oldContent.currentLength = oldLength;
  const addBehavior = {
    type: 'addFormBehavior',
    formTypeIdentifier: 'pipe',
    initialContent: newContent
  };
  const newFormID = await evaluateSource(addBehavior, content, parentContentPath, transientContext, nativeFunctions);
  if (newFormID === undefined) {
    await alertResult('Error', 'Unable to create new pipe.');
    return;
  }
  const clear = {
    barcodes: null,
    parts: null,
    bends: null,
    stage: null
  };
  const patchBehavior = {
    type: 'patchContentBehavior',
    patches: [clear, oldContent]
  };
  const patchedContent = await evaluateSource(patchBehavior, content, parentContentPath, transientContext, nativeFunctions);
  if (patchedContent === undefined) {
    await alertResult('Error', 'Unable to update old pipe.');
    return;
  }
  await alertResult('Success', 'New pipe created and original pipe updated.');
};
module.exports = {
  evaluate
};